/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function StyleManager(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'StyleManager',
      'aria-hidden': true,
      focusable: false,
      width:  19 * scale,
      height: 15 * scale,
      viewBox: '0 0 19 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M1 6.466C1 7.866 2.118 9 3.496 9S5.99 7.865 5.99 6.466 4.898 3.44 3.496 1C2.092 3.44 1 5.066 1 6.466M15.506 1c-1.404 2.44-2.496 4.066-2.496 5.466S14.128 9 15.506 9 18 7.865 18 6.466 16.908 3.44 15.506 1M7 11.466C7 12.866 8.118 14 9.496 14s2.494-1.135 2.494-2.534S10.898 8.44 9.496 6C8.092 8.44 7 10.066 7 11.466"}))
}
